export const BASE_URL = "https://api-ekaly.tana.team";
// export const BASE_URL = "http://127.0.0.1:8000";
